<template>
    <div>
        <span class="relative z-0 inline-flex shadow-sm rounded-md">
            <button
                @click="addSessions"
                type="button"
                class="relative inline-flex items-center px-4 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
            >
                {{ $tc('messages.add_sessions', 1) }}
            </button>
            <span class="-ml-px relative block">
                <button
                    type="button"
                    @click="open = true"
                    class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                    id="option-menu-button"
                    aria-expanded="true"
                    aria-haspopup="true"
                >
                    <span class="sr-only">Open options</span>
                    <!-- Heroicon name: solid/chevron-down -->
                    <svg
                        class="h-5 w-5"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clip-rule="evenodd"
                        />
                    </svg>
                </button>
            </span>
        </span>

        <SlideOver :show="open" @close="open = false">
            <form
                :action="route('programming-subjects.sessions.store', programming_subject.id)"
                method="post"
                @submit.prevent="submit"
            >
                <div>
                    {{ $tc('messages.add_sessions', 2) }} -
                    {{ programming_subject.subject.name }}
                </div>

                {{ $t('messages.quantity') }}

                <input
                    type="number"
                    min="1"
                    max="100"
                    required
                    v-model="form.quantity"
                    class="w-full border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm"
                />
                <div :class="form.quantity >= 30 ? 'visible' : 'invisible'">
                    <AlertMessage class="mt-5 inline-block">
                        <template v-slot:title>
                            {{ $t('messages.warning') }}
                        </template>
                        <template v-slot:body>
                            <span class="font-mono">{{ form.quantity }}</span> {{ $tc('messages.sessions', 2) }}.
                            {{ $t('messages.are_you_sure?') }}
                        </template>
                    </AlertMessage>
                </div>

                <FormError :value="form.errors.quantity" class="mt-2" />

                <input type="hidden" name="programming_subject_id" :value="programming_subject.id" />

                <SubmitFormButton :button-text="$t('messages.add')" :processing="form.processing" class="mt-3" />
            </form>
        </SlideOver>
    </div>
</template>
<script>
import FormError from '@/components/Forms/FormError.vue';
import AlertMessage from '@/components/AlertMessage.vue';
import SlideOver from '@/components/SlideOver.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    name: 'AddSubjectSessionsForm',
    props: {
        programming_subject: {},
    },
    components: {
        SubmitFormButton,
        SlideOver,
        FormError,
        AlertMessage,
    },
    emits: ['programmingUpdated'],
    data() {
        return {
            open: false,
            form: this.$inertia.form({
                quantity: 1,
            }),
        };
    },
    methods: {
        addSessions() {
            this.$inertia.post(
                this.route('programming-subjects.sessions.store', this.programming_subject.id),
                {
                    quantity: 1,
                },
                {
                    preserveScroll: true,
                    onSuccess: () => this.$emit('programmingUpdated'),
                },
            );
        },
        submit() {
            this.form.post(this.route('programming-subjects.sessions.store', this.programming_subject.id), {
                onSuccess: () => {
                    this.open = false;
                    this.quantity = 1;
                    this.$emit('programmingUpdated');
                },
                preserveScroll: true,
            });
        },
    },
};
</script>
